module.exports = __webpack_public_path__ + "static/media/0027_IMG_LES_STRUCTURES_GONDOLES.612c60e1.webp";